/* global $ module require */
'use_strict';

import { StateSelector } from '../tv_utils/state_selector';

/**
 * Class to setup the State Selector.
 */
export class StateSelectorView {
    /**
     * Initialize a new StateSelector Class.
     *
     * @returns {void}
     */
    constructor() {
        const stateSelector = new StateSelector();
        stateSelector.init();
    }

}

/**
 * Catch when a country drop down is changed so we can update the states.
 *
 * @returns {void}
 */
export function init() {
    if (document.getElementById('country')) {
        (() => new StateSelectorView())();
    }

}
